import i18n from '@/i18n'

export default ({ app }) => {
    // Set i18n instance on app
    app.i18n = i18n
}

export { i18n }
